import './LinkButton.css'

const LinkButton = ({ url, name, className = '' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <a
      className={`link-btn ${className} ${!url ? 'disabled' : ''}`}
      href={url}
      disabled={!url}
      onClick={(e) => handleClick(e)}
    >
      {name}
    </a>
  );
};

export default LinkButton